// Booking and enquiry analytics (SJM-1013: an event for each booking step, and for drop-off).
// Off unless "Send booking analytics events" is ticked in Booking Site Settings - the server then
// sets `window.sjmBookingAnalyticsConfig = { enabled: true }` (see Flypress\Site\SiteEnqueue).
//
// Events are pushed to `window.dataLayer` (GTM/GA4) and, when the HubSpot tracking code is on the
// page, to `_hsq` as custom behavioural events. Where they're collected is still to be confirmed
// (SJM-1013 plan Q7). No personal details are ever sent - only programme names, steps, audiences,
// year levels and counts.
//
// Markup declares events, so the same code covers page loads and AJAX-swapped wizard steps:
//   [data-track-view="event"]  fires once when rendered (call scan(root) after inserting HTML)
//   [data-track-event="event"] fires on click
//   [data-track-props='{"k":"v"}'] extra properties for either
(() => {
    "use strict";

    const config  = window.sjmBookingAnalyticsConfig || {};
    const enabled = !!config.enabled;

    // Drop-off: a booking or enquiry counts as started when one of its steps is viewed, and as
    // finished when its "submitted" view fires. Leaving the page in between sends an abandon event
    // with the last step seen.
    const FINISH_EVENTS = ['booking_submitted', 'booking_dates_request_submitted', 'enquiry_submitted'];
    let journey = null; // { kind, last_step, props }

    function parseProps(el) {
        try {
            return el.dataset.trackProps ? JSON.parse(el.dataset.trackProps) : {};
        } catch (_) {
            return {};
        }
    }

    function track(event, props) {
        if (!enabled) return;

        const payload = Object.assign({ event: event, booking_site: true }, props || {});

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);

        if (Array.isArray(window._hsq)) {
            window._hsq.push(['trackCustomBehavioralEvent', { name: event, properties: props || {} }]);
        }
    }

    function noteJourney(event, props) {
        if (FINISH_EVENTS.includes(event)) {
            journey = null;
            return;
        }

        if (event === 'booking_step_view') {
            journey = { kind: 'booking', last_step: props.step, props: { programme: props.programme } };
        } else if (event === 'enquiry_step_view') {
            journey = { kind: 'enquiry', last_step: props.step || 'form', props: { type: props.type } };
        }
    }

    function scan(root) {
        (root || document).querySelectorAll('[data-track-view]').forEach((el) => {
            if (el.dataset.trackViewSent) return;
            el.dataset.trackViewSent = '1';

            const props = parseProps(el);
            track(el.dataset.trackView, props);
            noteJourney(el.dataset.trackView, props);
        });
    }

    document.addEventListener('click', (e) => {
        const el = e.target.closest('[data-track-event]');
        if (el) track(el.dataset.trackEvent, parseProps(el));
    });

    // pagehide (not unload/beforeunload) also fires on mobile tab switches and bfcache entries.
    window.addEventListener('pagehide', () => {
        if (!journey) return;

        track(journey.kind === 'booking' ? 'booking_abandon' : 'enquiry_abandon', Object.assign({ last_step: journey.last_step }, journey.props));
        journey = null;
    });

    window.sjmBookingAnalytics = {
        track: track,
        scan: scan,
        /** Records a step change that happens without new markup (the corporate enquiry's client-side steps). */
        step(kind, step, props) {
            const event = kind === 'booking' ? 'booking_step_view' : 'enquiry_step_view';
            const all   = Object.assign({ step: step }, props || {});
            track(event, all);
            noteJourney(event, all);
        },
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => scan(document));
    } else {
        scan(document);
    }
})();
